import { CellData as t } from "./index.es758.js";
import { RowData as e } from "./index.es759.js";
class c {
  createRow(r) {
    return new e(r, this);
  }
  createCell(r) {
    return new t(r);
  }
}
export {
  c as DataGridFactory
};
//# sourceMappingURL=index.es639.js.map
